// src/services/offline.ts
// Helper servis za offline red i retry prema BE kroz Tauri komande.
// Za Web/TV app vidi posebnu SW varijantu (IndexedDB). Ovo je za Tauri (Win).

import { invoke } from "@tauri-apps/api/core";

// Generički enqueue HTTP request-a kad nema interneta/server pada
export async function queue(
  method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE",
  url: string,
  headers: Record<string, string> = {},
  body?: any
) {
  const headersJson = JSON.stringify(headers || {});
  const b64 =
    body == null
      ? null
      : btoa(typeof body === "string" ? body : JSON.stringify(body));

  await invoke("queue_request", {
    method,
    url,
    headersJson,
    bodyB64: b64,
  });
}

// Jedan prolaz reda (do 50 poruka po pozivu sa BE strane u Tauri main.rs)
export async function processQueue(baseUrl: string, token: string) {
  const okCount = await invoke<number>("process_queue", { baseUrl, token });
  return okCount;
}

// Pomagači: specifični enqueue-i koje ćeš zvati iz POS logike
export async function enqueueOrderCreate(payload: any, token: string) {
  await queue(
    "POST",
    "/api/pos/orders",
    {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    payload
  );
}

export async function enqueueOrderStatusUpdate(
  orderId: string | number,
  payload: any,
  token: string
) {
  await queue(
    "PATCH",
    `/api/pos/orders/${orderId}/status`,
    {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    payload
  );
}

// Jednostavni loop (npr. pozovi u useEffect u POS root-u)
let _flushTimer: number | null = null;
export function startFlushLoop(baseUrl: string, token: string, intervalMs = 5000) {
  stopFlushLoop();
  // @ts-ignore
  _flushTimer = window.setInterval(async () => {
    try {
      await processQueue(baseUrl, token);
    } catch (e) {
      // tišina — ostaje za kasnije pokušaje
    }
  }, intervalMs);
}

export function stopFlushLoop() {
  if (_flushTimer) {
    // @ts-ignore
    clearInterval(_flushTimer);
    _flushTimer = null;
  }
}
